import { Box, Button } from "@mui/material";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { HoverBadge } from "../hover-badge";

import type { PreviewProps } from "./types";
import type { FC } from "react";

export const HeaderTextPreview: FC<PreviewProps> = (props) => {
  const { header } = props.data;

  return (
    <Box sx={{ width: "100%" }}>
      <ConditionalWrapper
        condition={props.badgeProps !== undefined}
        wrapper={(children) => (
          <HoverBadge badgeContent="Text" name="header_text" {...props.badgeProps}>
            {children}
          </HoverBadge>
        )}
      >
        <Button
          data-analytics-id="email-design-header-text-preview"
          sx={{
            width: "100%",
            justifyContent: header?.text?.align,
            color: header?.text?.color,
          }}
        >
          {header?.text?.value || "Your header text here"}
        </Button>
      </ConditionalWrapper>
    </Box>
  );
};
